import { gql } from '@apollo/client';

const QUERY = gql`
  query Installments($orderId: ID!) {
    installments(orderId: $orderId) {
      id
      amount
      feeAmount
      paidAt
      scheduledDate
      transactionId
      status
      paymentMethod {
        accountType
        accountName
        last_4
      }
    }
  }
`;

export default QUERY;
